import { Clickable } from '@shared/Frontend/components/clickable'
import { useInView } from '@shared/Frontend/hooks/useInView'
import { pushDatalayer } from '@shared/Frontend/seo/datalayer'
import { cn } from '@shared/Frontend/utils/addToClassName'
import { slugify } from '@shared/Frontend/utils/slugify'
import * as React from 'react'
import { CtaBlock } from '../../blocks.state'

export const CTABlockLayout = (props: CtaBlock & { id: string }) => {
  const { id, bgColour, intro, label, primaryUpdater, secondaryUpdater, showUpdaterAsLink, title } = props
  const { inView, ref } = useInView({ threshold: 0.1 })
  const hasPrimaryUpdater = primaryUpdater && primaryUpdater.title && primaryUpdater.url
  const hasSecondaryUpdater = secondaryUpdater && secondaryUpdater.title && secondaryUpdater.url
  return (
    <section
      id={id}
      ref={ref}
      className={cn('block block--cta cta--text ls-block-spacing', bgColour && `bg--${bgColour}`, inView && 'inview')}
    >
      <div className="block__inner ls-container">
        <div className="block__layout ls-columns">
          {(title || label) && (
            <header className="block__header ls-columns__sidebar">
              <div>
                <div className="block__header-inner ls-reversed-column">
                  {title && (
                    <h2 id={slugify(title)} className="block__title title--m">
                      {title}
                    </h2>
                  )}
                  {/* NB: Van Oord doesn't have a label in CTA */}
                  {/* {label && <p className="block__label">{label}</p>} */}
                </div>
              </div>
            </header>
          )}

          <div className="block__content ls-columns__main-text">
            {intro && <p className="block__text" dangerouslySetInnerHTML={{ __html: intro }} />}

            {(hasPrimaryUpdater || hasSecondaryUpdater) && (
              <footer className="block__footer ls-clickables">
                {hasPrimaryUpdater && (
                  <div className="ls-clickable">
                    <Clickable
                      elementKind="link"
                      styleKind={showUpdaterAsLink ? 'link' : 'button'}
                      {...primaryUpdater}
                      className="outline-button"
                      onClick={() =>
                        pushDatalayer({
                          category: 'CTABlock',
                          action: primaryUpdater.title
                        })
                      }
                    />
                  </div>
                )}
                {hasSecondaryUpdater && (
                  <div className="ls-clickable">
                    <Clickable
                      elementKind="link"
                      styleKind="link"
                      {...secondaryUpdater}
                      className="outline-button"
                      onClick={() =>
                        pushDatalayer({
                          category: 'CTABlock',
                          action: secondaryUpdater.title
                        })
                      }
                    />
                  </div>
                )}
              </footer>
            )}
          </div>

          {/* NB: Van Oord doesn't use image in CTA */}
          {/* {image && (
            <div className="block__visual">
              <Image {...image} loading="lazy" className="block__image" width="620" height="620" />
            </div>
          )} */}
        </div>
      </div>
    </section>
  )
}
